import { DEBUG } from './global.js';

DEBUG && console.log("**** login.js file is loaded!****")

document.addEventListener("turbolinks:load", () =>
{
    DEBUG && console.log("**** turbolinks:load ****")

    let signupForm        = document.querySelector("#signup");
    let signinForm        = document.querySelector("#signin");
    let resetPasswordForm = document.querySelector("#reset-password");
    let loginForm         = document.querySelector("#login-form");
    
    /*
    if (signupForm == null)
        console.error("sign up form not found");

    if (signinForm == null)
        console.error("sign in form not found");

    if (resetPasswordForm == null)
        console.error("reset password form not found");       
    
    if (loginForm == null)
        console.error("login form button not found");
    */

    if (loginForm)
    {
        loginForm.addEventListener("click", (event)=>
        {
            event.stopPropagation();
    
            DEBUG && console.log("event", event);
    
            switch (event.target.id)
            {
                case "already-registered":
                    signupForm.style.display        = "none";
                    signinForm.style.display        = "block";
                    resetPasswordForm.style.display = "none";
                    break;
    
                case "forgot-password":
                    signupForm.style.display        = "none";
                    signinForm.style.display        = "none";
                    resetPasswordForm.style.display = "block";
                    break;
    
                case "not-registered":
                    signupForm.style.display        = "block";
                    signinForm.style.display        = "none";
                    resetPasswordForm.style.display = "none";
                    break;
    
                case "button":
                    let messageBox = document.querySelector(".message-box");
    
                    if (messageBox == null)
                        console.error("MessageBox not found");
    
                    messageBox.style.display = "none";
                    break;
    
                default:
                    break;
            }
        });
    }
});